import React, { Component } from "react";
import { Button, Form, Message } from "semantic-ui-react";
import api from "../../../../api";

class OrderForm extends Component {

    constructor(props) {
        super(props);

        this.state = {
            supplier_id: null,
            amount: props.orderAmount,
            selectedSupplier: null,
            selectedSupplierPrice: null,
            supplierPrices: [],
            newPrice: null,
            newCode: null,
            newMinQuantity: null,
            newPackageQuantity: null,
            changedPrice: false,
            errors: {}
        };
    }


    validate() {

        let errors = {};

        if (this.state.selectedSupplierPrice.minQuantity > this.state.amount) {
            errors.amount = "Amount bellow min. quantity";
        }

        if (this.state.amount % this.state.selectedSupplierPrice.packageQuantity !== 0) {
            errors.amount = "Amount does not fit the package size";
        }

        this.setState({
            errors
        });

        return errors;
    }

    render() {
        return (
            <div>
                <Form onSubmit={() => {
                    if (Object.keys(this.validate()).length !== 0) {
                        return;
                    }
                    this.props.onSubmit(this.state.amount, this.state.supplier_id, this.state.selectedSupplierPrice.code, this.state.selectedSupplierPrice.price);
                }}
                      error={Object.keys(this.state.errors).length > 0}
                >
                    <Form.Dropdown
                        value={this.state.supplier_id}
                        fluid
                        label={"Supplier"}
                        search
                        disabled={!this.props.active}
                        selection
                        options={this.props.suppliers ? this.props.suppliers
                            .filter((supplier) => {
                                return supplier.prefix !== null;
                            })
                            .map((supplier) => {
                                return {
                                    key: supplier.id,
                                    text: supplier.name + " (" + supplier.supplier_id + ")",
                                    value: supplier.id,
                                    style: { backgroundColor: this.props.supplierPrices[this.props.product.id] && this.props.supplierPrices[this.props.product.id][supplier.id] && "green" }
                                };
                            })
                            .sort((a, b) => {
                                if (this.props.supplierPrices[this.props.product.id] && this.props.supplierPrices[this.props.product.id][a.id]) {
                                    return 1;
                                }

                                if (this.props.supplierPrices[this.props.product.id] && this.props.supplierPrices[this.props.product.id][b.id]) {
                                    return -1;
                                }

                                return a.id > b.id;
                            }) : []}
                        onChange={(e, { value }) => {
                            this.setState({
                                supplier_id: value,
                                selectedSupplier: this.props.suppliers.reduce((a, b) => {
                                    if (b.id === value) {
                                        return b;
                                    }
                                    return a;
                                }, {}),
                                selectedSupplierPrice: null,
                                changedPrice: false
                            });
                        }}
                    />
                    {this.state.selectedSupplier &&

                    <div>

                        <Form.Dropdown
                            fluid
                            search
                            value={this.state.selectedSupplierPrice && this.state.selectedSupplierPrice.id}
                            onChange={(e, { value }) => {

                                if (value === 0) {
                                    this.setState({
                                        selectedSupplierPrice: null,
                                        newPrice: 1,
                                        newMinQuantity: 1,
                                        newPackageQuantity: 1,
                                        newCode: ""
                                    });
                                } else {
                                    this.setState({
                                        selectedSupplierPrice: this.props.supplierPrices[this.props.product.id][this.state.selectedSupplier.id].reduce(((a, b) => {
                                            if (b.id === value) {
                                                return b;
                                            }
                                            return a;
                                        }), {}),
                                        amount: this.props.supplierPrices[this.props.product.id][this.state.selectedSupplier.id].reduce(((a, b) => {
                                            if (b.id === value) {
                                                return b.minQuantity;
                                            }
                                            return a;
                                        }), 0),
                                        newPrice: null,
                                        newMinQuantity: null,
                                        newPackageQuantity: null,
                                        newCode: null
                                    });
                                }
                            }}
                            label={"Supplier Price"}
                            selection
                            options={
                                this.props.supplierPrices[this.props.product.id] &&
                                this.props.supplierPrices[this.props.product.id][this.state.selectedSupplier.id] ?
                                    [
                                        ...[{
                                            key: 0,
                                            text: "Create New Supplier Price",
                                            value: 0
                                        }],
                                        ...this.props.supplierPrices[this.props.product.id][this.state.selectedSupplier.id].map((price) => {
                                            return {
                                                key: price.id,
                                                text: price.price + " min=" + price.minQuantity + " unit=" + price.packageQuantity,
                                                value: price.id
                                            };
                                        })
                                    ] : [{
                                        key: 0,
                                        text: "Create New Supplier Price",
                                        value: 0
                                    }]
                            }

                        />

                        {this.state.newPrice &&
                        <div>

                            <Form.Field
                                value={this.state.newCode}
                                disabled={!this.props.active}
                                onChange={(e) => {
                                    this.setState({
                                        newCode: e.target.value
                                    });
                                }}
                                label='Supplier Code' control='input' type='text'
                                required
                            />
                            <Form.Field
                                value={this.state.newPrice}
                                disabled={!this.props.active}
                                onChange={(e) => {
                                    this.setState({
                                        newPrice: e.target.value
                                    });
                                }}
                                label='New Price' control='input' type='number' min={0.01}
                                step={0.01}
                            />
                            <Form.Field
                                value={this.state.newMinQuantity}
                                disabled={!this.props.active}
                                onChange={(e) => {
                                    this.setState({
                                        newMinQuantity: e.target.value
                                    });
                                }}
                                label='Min Quantity' control='input' type='number' min={1}
                                step={1}
                            />

                            <Form.Field
                                value={this.state.newPackageQuantity}
                                disabled={!this.props.active}
                                onChange={(e) => {
                                    this.setState({
                                        newPackageQuantity: e.target.value
                                    });
                                }}
                                label='Package Quantity' control='input' type='number' min={1}
                                step={1}
                            />
                            <Button fluid onClick={(e) => {
                                e.preventDefault();


                                api.setSupplierPrice(this.props.product.id, this.state.selectedSupplier.id, this.state.newCode, this.state.newPrice, this.state.newMinQuantity, this.state.newPackageQuantity)
                                    .then((newPrice) => {
                                        this.setState({
                                            selectedSupplierPrice: newPrice,
                                            newPrice: null,
                                            newCode: null,
                                            newMinQuantity: null,
                                            newPackageQuantity: null
                                        });

                                        this.props.onRefreshPrices();
                                    });

                            }}>Save</Button>
                        </div>
                        }

                        {this.state.selectedSupplierPrice &&

                        <div>
                            <Form.Field value={this.state.selectedSupplierPrice.price}
                                        disabled={!this.props.active}
                                        onChange={(e) => {
                                            let value = JSON.parse(JSON.stringify(e.target.value));
                                            this.setState((state) => {
                                                return {
                                                    selectedSupplierPrice: {
                                                        ...state.selectedSupplierPrice,
                                                        price: value
                                                    },
                                                    changedPrice: true
                                                };
                                            });
                                        }} label='Price' control='input' type='number' min={0.01}
                                        step={0.01}/>
                            <Form.Field value={this.state.selectedSupplierPrice.minQuantity}
                                        disabled={!this.props.active}
                                        onChange={(e) => {
                                            let value = JSON.parse(JSON.stringify(e.target.value));
                                            this.setState((state) => {
                                                return {
                                                    selectedSupplierPrice: {
                                                        ...state.selectedSupplierPrice,
                                                        minQuantity: value
                                                    },
                                                    changedPrice: true
                                                };
                                            });
                                        }} label='Min. Quantity' control='input' type='number'
                                        min={1}
                                        step={1}/>
                            <Form.Field value={this.state.selectedSupplierPrice.packageQuantity}
                                        disabled={!this.props.active}
                                        onChange={(e) => {
                                            let value = JSON.parse(JSON.stringify(e.target.value));
                                            this.setState((state) => {
                                                return {
                                                    selectedSupplierPrice: {
                                                        ...state.selectedSupplierPrice,
                                                        packageQuantity: value
                                                    },
                                                    changedPrice: true
                                                };
                                            });
                                        }} label='Package Quantity' control='input' type='number'
                                        min={1}
                                        step={1}/>
                            <Form.Field value={this.state.selectedSupplierPrice.code}
                                        disabled={!this.props.active}
                                        onChange={(e) => {
                                            let value = JSON.parse(JSON.stringify(e.target.value));
                                            this.setState((state) => {
                                                return {
                                                    selectedSupplierPrice: {
                                                        ...state.selectedSupplierPrice,
                                                        code: value
                                                    },
                                                    changedPrice: true
                                                };
                                            });
                                        }} label='Supplier Code' control='input' type='text'/>
                            <Form.Field value={this.state.amount}
                                        disabled={!this.props.active}
                                        error={this.state.errors && typeof this.state.errors.amount !== "undefined"}
                                        onChange={(e) => {
                                            this.setState({
                                                amount: e.target.value
                                            });
                                        }} label='Quantity' control='input' type='number'
                                        min={this.state.selectedSupplierPrice.minQuantity}
                            />
                            {this.state.errors && typeof this.state.errors.amount !== "undefined" &&
                            <Message
                                error
                                header='Quantity not allowed'
                                content={this.state.errors.amount}
                            />
                            }


                            {this.state.changedPrice &&
                            <Button
                                onClick={(e) => {
                                    e.preventDefault();
                                    api.setSupplierPrice(
                                        this.props.product.id,
                                        this.state.selectedSupplier.id,
                                        this.state.selectedSupplierPrice.code,
                                        this.state.selectedSupplierPrice.price,
                                        this.state.selectedSupplierPrice.minQuantity,
                                        this.state.selectedSupplierPrice.packageQuantity,
                                        this.state.selectedSupplierPrice.id
                                    )
                                        .then((price) => {
                                            this.setState({ changedPrice: false });
                                        });
                                }}
                            >Save Changed Price</Button>
                            }
                            {this.props.active ?

                                <div>
                                    {this.state.changedPrice === false &&
                                    <Button positive>Add to Order</Button>}
                                </div>
                                :
                                <Button negative type='button' onClick={(e) => {
                                    e.preventDefault();
                                    this.props.onRemove();
                                }}>Remove from Order</Button>
                            }

                        </div>
                        }


                    </div>
                    }

                </Form>
            </div>
        );
    }
}

export default OrderForm;



// WEBPACK FOOTER //
// ./src/scenes/Tools/scenes/Procurement/components/DetailTab/components/OrderForm/index.js